<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="title">版本介绍</span>
      </div>
      <div>
        <div class="explain">
          *免费版用户增加100个席位就可以升级为企业版用户，并可以从平台海量精品课程中选择20门课程终生使用
        </div>
        <el-table :data="tableData" style="width: 700px">
          <el-table-column prop="name" label="功能" width="180"> </el-table-column>
          <el-table-column prop="free" label="免费版" width="180">
            <template slot-scope="scope">
              <i v-if="scope.row.freeStatus" :class="scope.row.free" class="icon"></i>
              <div v-else>{{ scope.row.free }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="enterprise" label="企业版">
            <template slot-scope="scope">
              <i v-if="scope.row.enterpriseStatus" :class="scope.row.enterprise" class="icon"></i>
              <div v-else>{{ scope.row.enterprise }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          name: '平台使用费',
          free: '￥0.00元',
          freeStatus: false,
          enterprise: '￥0.00元(活动免除)',
          enterpriseStatus: false,
        },
        {
          name: '书院人数',
          free: '最多10人',
          freeStatus: false,
          enterprise: '数量不限（￥48.00元/人/年）',
          enterpriseStatus: false,
        },
        {
          name: '发布公告',
          free: 'el-icon-success',
          freeStatus: true,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '专属书院logo展示',
          free: 'el-icon-success',
          freeStatus: true,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '专属书院名称展示',
          free: 'el-icon-success',
          freeStatus: true,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '管理员管理',
          free: 'el-icon-success',
          freeStatus: true,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '课程商城',
          free: 'el-icon-success',
          freeStatus: true,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '更换管理员管理',
          free: 'el-icon-success',
          freeStatus: true,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '添加员工',
          free: 'el-icon-success',
          freeStatus: true,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '外训师预约',
          free: 'el-icon-success',
          freeStatus: true,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '创建班级',
          free: '1个',
          freeStatus: false,
          enterprise: '不限',
          enterpriseStatus: false,
        },
        {
          name: '上传视频',
          free: '50个',
          freeStatus: false,
          enterprise: '不限',
          enterpriseStatus: false,
        },
        {
          name: '创建课程',
          free: '1门',
          freeStatus: false,
          enterprise: '不限',
          enterpriseStatus: false,
        },
        {
          name: '员工学习记录',
          free: '无',
          freeStatus: false,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '批量添加员工',
          free: '无',
          freeStatus: false,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '直播课程',
          free: '无',
          freeStatus: false,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '考试系统',
          free: '无',
          freeStatus: false,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '随机试卷',
          free: '无',
          freeStatus: false,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '自定义试卷',
          free: '无',
          freeStatus: false,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '问卷系统',
          free: '无',
          freeStatus: false,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '自定义问卷',
          free: '无',
          freeStatus: false,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '自定义Banner图',
          free: '无',
          freeStatus: false,
          enterprise: 'el-icon-success',
          enterpriseStatus: true,
        },
        {
          name: '赠送福利',
          free: '无',
          freeStatus: false,
          enterprise: '任意选择20门精品课程',
          enterpriseStatus: false,
        },
      ],
    }
  },
  created() {},
  methods: {},
}
</script>

<style scoped lang="scss">
.box-card {
  .title {
    font-size: 18px;
  }
  .explain {
    font-size: 16px;
    margin: 20px 0;
    color: #333;
  }
  .icon {
    font-size: 22px;
    color: #67c23a;
  }
}
</style>
